import { render } from "./PrintViewServiceCard.vue?vue&type=template&id=55c418c4&scoped=true"
import script from "./PrintViewServiceCard.vue?vue&type=script&lang=js"
export * from "./PrintViewServiceCard.vue?vue&type=script&lang=js"

import "./PrintViewServiceCard.vue?vue&type=style&index=0&id=55c418c4&scoped=true&lang=css"
import "./PrintViewServiceCard.vue?vue&type=style&index=1&id=55c418c4&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c418c4"]])

export default __exports__